module.exports = __webpack_public_path__ + "static/media/12.63d94c7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/12.wav
// module id = aZ8k
// module chunks = 0